import { render, staticRenderFns } from "./ClientNotes.vue?vue&type=template&id=e8e67670&scoped=true"
import script from "./ClientNotes.vue?vue&type=script&lang=ts"
export * from "./ClientNotes.vue?vue&type=script&lang=ts"
import style0 from "./ClientNotes.vue?vue&type=style&index=0&id=e8e67670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e67670",
  null
  
)

export default component.exports